import React, { useState, useEffect } from 'react'
import { useAppSelector } from 'hooks/store'

import CustomModal from 'components/organisms/CustomModal'
import './styles.scss'

export interface InstructionsModalProps {
  show: boolean
  caseId: number
  onHide: () => void
}

const QuestionnaireInstructionsModal = (
  props: InstructionsModalProps
): JSX.Element => {
  const activeCase = useAppSelector((state) => state.activeCase)
  const [instructions, setInstructions] = useState('')

  useEffect(() => {
    if (activeCase) {
      if (activeCase.matter) {
        if (activeCase.matter.questionnaireInstructions) {
          setInstructions(activeCase.matter.questionnaireInstructions)
        }
      }
    }
  }, [activeCase])

  return (
    <CustomModal
      show={props.show}
      showClose={true}
      showFooter={true}
      onHide={props.onHide}
      title='Questionnaire Instructions'
      footerButtons={[
        {
          text: 'Close',
          onClick: props.onHide,
          variant: 'secondary',
          testid: 'questionnaire-instructions-modal-close-button'
        }
      ]}
    >
      <div
        className='questionnaire-instructions-modal-text'
        data-testid='questionnaire-instructions-modal-test'
      >
        {instructions}
      </div>
    </CustomModal>
  )
}

export default QuestionnaireInstructionsModal
